import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import Logic from '../../Logic';

const NonValidatedField = (props) => {
  let logic = new Logic();
  return (
    <div className={'form-group col-sm-'+props.cols}>
      <label>{props.label}</label>
      <Field 
      {...props} 
      name={props.name} 
      tabIndex={props.tabIndex || 0} 
      className="form-control" 
      component="input" 
      autoComplete="off" 
      type={props.type}
      // value={props.name.toLowerCase().indexOf('date') > -1 ? logic.formatDate(input.value) : input.value } 
      placeholder={props.placeholder}/>
    </div> 
    );
  };
  
export default NonValidatedField;
  